export default "__VITE_ASSET__B2YgnU26__"